
import CallingIcon from '../../assets/icons/CallingIcon';
import ChuteIcon from '../../assets/icons/ChuteIcon';
import ClockIcon from '../../assets/icons/ClockIcon';
import CloseIcon from '../../assets/icons/Close';
import DownloadDocumentIcon from '../../assets/icons/DownloadDocumentIcon';
import EightWheelerTruckIcon from '../../assets/icons/EightWheelerTruckIcon';
import EmailIcon from '../../assets/icons/EmailIcon';
import InvoiceIcon from '../../assets/icons/InvoiceIcon';
import LabelIcon from '../../assets/icons/LabelIcon';
import LifeBeltIcon from '../../assets/icons/LifeBeltIcon';
import MapPinIcon from '../../assets/icons/MapPinIcon';
import OrdersIcon from '../../assets/icons/OrdersIcon';
import ProfileIcon from '../../assets/icons/ProfileIcon';
import PumpTruckIcon from '../../assets/icons/PumpTruckIcon';
import QuoteIcon from '../../assets/icons/QuoteIcon';
import ReferralsIcon from '../../assets/icons/ReferralsIcon';
import SendIcon from '../../assets/icons/SendIcon';
import SignoutIcon from '../../assets/icons/SignoutIcon';
import SixWheelerTruckIcon from '../../assets/icons/SixWheelerTruckIcon';
import TaskIcon from '../../assets/icons/TaskIcon';
import TenWheelerTruckIcon from '../../assets/icons/TenWheelerTruckIcon';
import TruckSilhouetteIcon from '../../assets/icons/TruckSilhouetteIcon';
import WheelbarrowIcon from '../../assets/icons/WheelbarrowIcon';
import CalendarIcon from '../../assets/icons/CalendarIcon';

import { memo } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ReactElement} from 'react';

export interface GetIconProps extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
  icon?: string | null;
}

const GetIconSwitch = ({ icon, ...props }: GetIconProps) => {
  switch (icon) {
    case 'chute':
      return <ChuteIcon {...props} />;
    case 'wheelbarrow':
      return <WheelbarrowIcon {...props} />;
    case 'pumpTruck':
      return <PumpTruckIcon {...props} />;
    case 'sixWheeler':
      return <SixWheelerTruckIcon {...props} />;
    case 'eightWheeler':
      return <EightWheelerTruckIcon {...props} />;
    case 'tenWheeler':
      return <TenWheelerTruckIcon {...props} />;
    case 'truckSilhouette':
      return <TruckSilhouetteIcon {...props} />;
    case 'orders':
      return <OrdersIcon {...props} />;
    case 'calling':
      return <CallingIcon {...props} />;
    case 'profile':
      return <ProfileIcon {...props} />;
    case 'signout':
      return <SignoutIcon {...props} />;
    case 'invoice':
      return <InvoiceIcon {...props} />;
    case 'downloadDocument':
      return <DownloadDocumentIcon {...props} />;
    case 'send':
      return <SendIcon {...props} />;
    case 'mappin':
      return <MapPinIcon {...props} />;
    case 'email':
      return <EmailIcon {...props} />;
    case 'referrals':
      return <ReferralsIcon {...props} />;
    case 'close':
      return <CloseIcon {...props} />;
    case 'clock':
      return <ClockIcon {...props} />;
    case 'label':
      return <LabelIcon {...props} />;
    case 'lifebelt':
      return <LifeBeltIcon {...props} />;
    case 'task':
      return <TaskIcon {...props} />;
    case 'quote':
      return <QuoteIcon {...props} />;
    case 'calendar':
      return <CalendarIcon {...props} />;
    default:
      return null;
  }
};

function GetIcon({ icon, style, ...props }: GetIconProps): ReactElement {
  const extraStyles = Array.isArray(style) ? style[0] : style;
  return <GetIconSwitch {...props} icon={icon} style={extraStyles} />;
}

export default memo(GetIcon);
